import type { PlatformValue } from "shared";

export interface PlatformConnectionState {
	platform: PlatformValue;
	connected: boolean;
}

/** The set of platforms this company has actually connected in Settings. */
export const buildConnectedPlatforms = (
	states: PlatformConnectionState[],
): Set<PlatformValue> =>
	new Set(
		states.filter((state) => state.connected).map((state) => state.platform),
	);

/**
 * Which platforms a generate form should start with: the selectable ones the
 * company has connected. Unconnected platforms stay selectable, but the user has
 * to opt into them deliberately rather than getting content for every platform
 * by default.
 */
export const defaultSelectedPlatforms = (
	selectable: PlatformValue[],
	connected: Set<PlatformValue>,
): PlatformValue[] => selectable.filter((platform) => connected.has(platform));
